import { generateUUID } from "@utils";

export const SupplierPlacementId = generateUUID();
export const ConfigurationPlacementId = generateUUID();
export const SkeletonTabsNumber = 6;
export const DELAY_TIME = 700;
export const MINIMUM_DELAY_TIME = 300;
export const MINIMUM_SKELETON_DISPLAY_TIME = 300;
export const MAX_LONG_TEXT_LENGTH = 7000;
export const MAX_MEDIUM_TEXT_LENGTH = 3000;
